// extracted by mini-css-extract-plugin
module.exports = {"links":"style_links__vFIcj","link":"style_link__wD1Z0"};